import { useEffect, useState } from "react";
import PageHierarchy from "../page-hierarchy/page-hierarchy";
import "./availablility-chart.scss";
import { useDispatch, useSelector } from "react-redux";

import { Chart } from "primereact/chart";
import ChartWrapper from "../chart-wrapper/chart-wrapper";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { getICProductsByShopAtDate } from "../../productSlices";
import { Calendar } from "primereact/calendar";

const AvailabilityChart = () => {
    const dispatch: Function = useDispatch();
    const user = useSelector((state: any) => state.auth.user);
    const selectedShop = useSelector((state: any) => state.user.selectedShop);
    const ic_products = useSelector((state: any) => state.product.ic_products_at_date);
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});
    const [date, setDate] = useState(() => {
        const savedDate = localStorage.getItem(`${window.location.pathname}_date`);
        return savedDate ? new Date(savedDate) : new Date();
    });
    const global_three_liter = ic_products.reduce((accumulator ,item) => {
        return accumulator += item.three_liter;
        }, 0)
    const global_five_liter = ic_products.reduce((accumulator ,item) => {
        return accumulator += item.five_liter;
        }, 0)
    const global_seven_liter = ic_products.reduce((accumulator ,item) => {
        return accumulator += item.seven_liter;
        }, 0)

    
    useEffect(() => {
        if(!selectedShop) return
        if(!date) return
        localStorage.setItem(`${window.location.pathname}_date`, date.toISOString());
        dispatch(getICProductsByShopAtDate(selectedShop, date.toDateString().toString()))
    }, [selectedShop, date]);
    
    useEffect(() => {
        const data = {
            labels: ['3L pack', '5L pack', '7L pack'],
            datasets: [
                {   
                    label:'Packs',
                    data: [global_three_liter, global_five_liter, global_seven_liter],
                    backgroundColor: [
                        '#DDCAF1',
                        '#5FC9CA',
                        '#C3A3FA'
                    ],
                    hoverBackgroundColor: [
                        '#DDCAF1',
                        '#5FC9CA',
                        '#C3A3FA'
                    ],
                    borderWidth: 0
                }
            ]
        };
        const total = data.datasets[0].data.reduce((sum, value) => sum + value, 0);
        const options = {
            responsive: true,
            maintainAspectRatio: false,
            cutout: '60%',
            plugins: {
                legend: {
                    display: true,
                    position: 'top',
                    labels: {
                        usePointStyle: true, // Use dots for legends
                        generateLabels: (chart) => {
                            return chart.data.labels.map((label, index) => {
                                const value = chart.data.datasets[0].data[index];
                                const percentage = ((value / total) * 100).toFixed(0) + '%';
                                return {
                                    text: `${label}`,
                                    pointStyle: 'circle', // Specify point style
                                    fillStyle: chart.data.datasets[0].backgroundColor[index],
                                    hidden: false,
                                };
                            });
                        },
                    },
                },
                datalabels: {
                    color: '#000',
                    font: {
                        size: 12,
                        weight: 'bold',
                    },
                    formatter: (value) => {
                        const percentage = ((value / total) * 100).toFixed(0) + '%';
                        return percentage;
                    },
                    anchor: 'center',
                    align: 'center',
                    backgroundColor: '#ECEAF8', // Circle background
                    borderWidth: 1,
                    borderRadius: 20, // Circular shape
                    padding: 10, // Padding inside the circle
                },
            },
        };

        setChartData(data);
        setChartOptions(options);
    }, [global_three_liter, global_five_liter, global_five_liter, selectedShop]);

 return (
    <div className='availability-chart'>
        <Calendar locale="eu" dateFormat="dd/mm/yy" value={date} onChange={(e) => setDate(e.value)} selectionMode="single" readOnlyInput hideOnRangeSelection  placeholder="Select date"/>
         <Chart type="doughnut" data={chartData} options={chartOptions} plugins={[ChartDataLabels]} width="35vw" height="25vh"/>
    </div>
  );
};

export default AvailabilityChart;
